document.addEventListener("DOMContentLoaded", function() {
  const preview = document.getElementById("pdf-preview");
  const btn = document.getElementById("pdf-viewer");
  const spinner = document.getElementById("pdf-preview-spinner");

  let loaded = false;

  preview?.addEventListener('load', function () {
    spinner?.classList.remove("spinner");
    loaded = true;
  });

  btn?.addEventListener("click", function() {
    const wrapper = document.getElementById("pdf-wrapper");
    wrapper?.classList.toggle("d-flex");

    const isShowing = wrapper?.classList.contains("d-flex");

    if (isShowing) {
      if (!loaded) {
        spinner?.classList.add("spinner");
      }
    } else {
      spinner?.classList.remove("spinner");
    }
  });
});
